import React from "react";
import "../style/about.css";
import aboutsection2image from "../assets/aboutsection2image.png";

import { NavLink } from "react-router-dom";
import inlovewhite from "../assets/inlovewhite.png";
import starperson from "../assets/starperson.png";
import family from "../assets/family.png";
import markwhite from "../assets/markwhite.png";
import ContentBlock from "./ContentBlock";
import SlideShow from "./SlideShow";

const About = () => (
  <div className="about-container">
    <section className=" about-section1">
      <h1>About Serenity Residential Care</h1>
      <h4>
        Dedicated to providing exceptional residential care and support services
        for individuals
        <br /> with learning disabilities, mental health challenges, and
        physical disabilities.
      </h4>
    </section>
    <section className=" about-section2">
      <div className=" about-section2-div1">
        <h1>Our Story & Background</h1>
        <p>
          Our journey began in 2023, born from a shared calling to make a
          genuine difference in people’s lives. After years of working within
          the care sector gaining invaluable experience and insight we
          recognised a profound need for something more: a care environment
          grounded in compassion, dignity, and personalised support. So, we made
          a decision that would change our lives and hopefully the lives of many
          others. We founded our own care company.
        </p>
        <p>
          From day one, our vision has been clear: to create a place where every
          individual is valued, heard, and supported to thrive. We believe that
          care is not simply about meeting needs it’s about nurturing life,
          building relationships, and ensuring that every person feels at home,
          respected, and safe.
        </p>
        <p>
          With that belief , we set out to grow not just in size, but in impact.
          Our mission is to become a trusted provider of residential care
          services across the UK, known for our integrity, reliability, and
          heartfelt approach to care. While we embrace innovation and the
          evolving landscape of modern care practices and technologies, our
          founding principles remain at the heart of everything we do. Every
          decision we make is guided by our commitment to compassionate,
          professional care ensuring our residents not only receive support, but
          truly live well.
        </p>
        <p>
          Our motto says it best: "Nurturing Life, Embracing Care." Because for
          us, care is more than a service. It’s a promise.
        </p>

        <div className="section2-link">
          <NavLink to="/vision">Our Mission & Vision</NavLink>
        </div>
      </div>
      <ContentBlock>
        <div className=" about-section2-div2">
          <img src={aboutsection2image} alt=" about-image" loading="lazy" />
        </div>
      </ContentBlock>
    </section>
    <section className=" about-section3">
      <SlideShow />
    </section>
    <section className="about-section4">
      <div className="about-section4-div1">
        <h1 style={{ textAlign: "center" }}>Our Care Philosophy</h1>
      </div>
      <ContentBlock>
        <div className="about-section4-div2">
          <div className="about-section4-div2-items">
            <h3 className="section3div2-items-1">
              Person-Centered
              <br /> Approach
              <img src={inlovewhite} alt="inlove" loading="lazy" />
            </h3>
            <h5>
              Every individual is unique and so is
              <br /> our care. We create personalised care
              <br /> plans that focus on each resident’s
              <br /> needs, preferences, abilities, and
              <br /> aspirations, helping them live life <br /> on their own
              terms.
            </h5>
          </div>
          <div className="about-section4-div2-items">
            <h3 className="section3div2-items-1">
              Dignity & Respect
              <img src={starperson} alt="starperson" loading="lazy" />
            </h3>
            <h5>
              Respect for dignity is at the heart of
              <br /> everything we do. We promote
              <br /> independence, choice, and privacy
              <br /> while providing the support needed
              <br /> for each individual to live their best
              <br /> life possible
            </h5>
          </div>
        </div>
      </ContentBlock>
      <ContentBlock>
        <div className="about-section4-div3">
          <div className="about-section4-div2-items">
            <h3 className="section3div2-items-1">
              Family Partnership
              <img src={family} alt="family" loading="lazy" />
            </h3>
            <h5>
              We recognize the importance of family
              <br /> relationships and work collaboratively
              <br /> with families to ensure continuity of <br /> care and
              maintain meaningful
              <br /> connections. Families are always
              <br /> welcome and encouraged to be
              <br /> involved.
            </h5>
          </div>

          <div className="about-section4-div2-items">
            <h3 className="section3div2-items-1">
              Professional
              <br /> Excellence
              <img src={markwhite} alt="markwhite" loading="lazy" />
            </h3>
            <h5>
              Our team consists of qualified,
              <br /> experienced professionals who are
              <br />
              committed to ongoing training and
              <br /> development. We maintain the highest
              <br /> standards of care through continuous
              <br /> improvement and best practice
              <br /> implementation.
            </h5>
          </div>
        </div>
      </ContentBlock>
    </section>

    <section className="about-section5">
      <div className="about-section5-div1">
        <h1>Want to Learn More About Our Approach?</h1>
        <h3>
          We'd be happy to discuss how our person centered approach can support
          <br /> you or your loved one. Contact us today for a friendly,
          no-obligation
          <br /> conversation.
        </h3>

        <div className="about-section5-div1-navs">
          <NavLink to="/contact-us">Contact Us Today</NavLink>
          <NavLink to="/meet-our-team">Meet Our Team</NavLink>
        </div>
      </div>
    </section>
  </div>
);

export default About;
